export default {
	addresses: {
		createNew: 'Create new address',
	},
}
